/* eslint-disable max-classes-per-file */
export class PaymentOnHoldRequirement {
  label: string;

  onHold: string;

  totalNumberOfTrades: number;

  constructor(
    data: {
      label?: string;
      onHold?: string;
      totalNumberOfTrades?: number;
    } = {}
  ) {
    this.label = data.label || 'N/A';
    this.onHold = data.onHold || '$0';
    this.totalNumberOfTrades = data.totalNumberOfTrades || 0;
  }
}

export default class PaymentOnHoldSummary {
  amountOnHold?: string | null;

  totalNumberOfTrades?: number | null;

  requirements: PaymentOnHoldRequirement[];

  constructor(
    data: {
      amountOnHold?: string;
      totalNumberOfTrades?: number;
      requirements?: PaymentOnHoldRequirement[];
    } = {}
  ) {
    this.amountOnHold = data?.amountOnHold || null;
    this.totalNumberOfTrades = Number.isInteger(data?.totalNumberOfTrades)
      ? data?.totalNumberOfTrades
      : null;
    this.requirements = (data?.requirements || []).map(
      requirement => new PaymentOnHoldRequirement(requirement)
    );
  }
}
/* eslint-enable max-classes-per-file */
